export interface ReportsTypeValue {
  value: string;
  id: string;
}

interface ReportsTypeProps {
  [key: string]: ReportsTypeValue
}

export const reportsType: ReportsTypeProps = {
  1: {
    value: 'ESTOQUE',
    id: 'Estoque',
  },
  2: {
    value: 'ESTOQUE_ATUAL',
    id: 'Estoque Atual',
  },
  3: {
    value: 'COMPRA_VENDA',
    id: 'Compra e venda',
  },
  4: {
    value: 'MORTE',
    id: 'Morte',
  },
  5: {
    value: 'USO_SISTEMA',
    id: 'Uso do sistema',
  },
  6: {
    value: 'COBERTURA_DIAGNOSTICO',
    id: 'Cobertura e Diagnóstico de Gestação',
  },
  7: {
    value: 'PESAGENS',
    id: 'Pesagens',
  },
  8: {
    value: 'NASCIMENTOS',
    id: 'Nascimentos',
  },
  9: {
    value: 'GENETICA',
    id: 'Genética',
  },
  10: {
    value: 'OPERACOES_SANITARIAS',
    id: 'Operações Sanitárias',
  },
  11: {
    value: 'ESTOQUE_ANIMAL_IMAGEM',
    id: 'Estoque Animal Imagem',
  },
  12: {
    value: 'VACAS_DIAGNOSTICAR',
    id: 'Vacas a Diagnosticar',
  },
}


export const reportsTypeOptions = Object.keys(reportsType).map((key: string) => reportsType[key])
